export default __webpack_public_path__ + "static/media/356.78a86554.png";